// Robust app reload that survives the service-worker precache.
//
// A plain window.location.reload() can hit the OLD service worker's
// precached index.html (which references the OLD bundle hashes), so the
// user reloads but stays on the old build — the "new version available"
// banner therefore keeps showing even right after they tapped it.
//
// This helper:
//   1. Triggers a service-worker update and briefly waits for the new
//      SW to take control (sw.js calls skipWaiting on install and
//      clients.claim on activate).
//   2. Deletes the workbox precache caches as a safety net so the
//      upcoming navigation falls through the SW's nav handler
//      (matchPrecache → undefined → fetch network) and the server
//      returns the latest index.html with the new bundle hashes.
//   3. Calls window.location.reload().
//
// Use this from every "reload the app" entry point (banner, menu,
// sidebar, header, settings-change callbacks) so a stuck user can pick
// any of them and reliably end up on the latest build.
export default async function reloadApp() {
    try {
        if ('serviceWorker' in navigator) {
            const reg = await navigator.serviceWorker.getRegistration();
            if (reg) {
                const controllerChange = new Promise((resolve) => {
                    navigator.serviceWorker.addEventListener('controllerchange', resolve, { once: true });
                });
                await reg.update();
                if (reg.waiting) {
                    reg.waiting.postMessage({ type: 'SKIP_WAITING' });
                }
                if (reg.installing || reg.waiting) {
                    await Promise.race([
                        controllerChange,
                        new Promise((r) => setTimeout(r, 3000)),
                    ]);
                }
            }
        }
        if (typeof caches !== 'undefined' && caches.keys) {
            const cacheNames = await caches.keys();
            await Promise.all(
                cacheNames
                    .filter(name => /workbox-precache|^precache/i.test(name))
                    .map(name => caches.delete(name)),
            );
        }
    } catch (e) {
        // best-effort — fall through to plain reload
    }
    window.location.reload();
}
